// extracted by mini-css-extract-plugin
export default {"container":"OptionsGroup_container__jx-2+","label":"OptionsGroup_label__2nFRm","options":"OptionsGroup_options__p0sCM"};